// Daily-report PDF fields tab (admin).
// Part of the Reference page (components/Reference.jsx). Split out 2026-10-14.
import { useState, useEffect } from 'react';
import { useApi, putJson } from '../../api.js';

// ============================================================================
//  PdfFieldsPanel -- checkbox toggle for each field on the daily-report PDF
// ============================================================================
export default function PdfFieldsPanel() {
  // Data: every field the Daily Ops PDF can show, and which are switched on.
  const { data, loading, error, refresh } = useApi('/api/daily-report/pdf-fields');
  const [include, setInclude] = useState({});
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);
  useEffect(() => {
    if (data && data.include) setInclude({ ...data.include });
  }, [data]);
  // Actions: save, tick / untick all.
  async function save() {
    setSaving(true); setMsg(null);
    try {
      await putJson('/api/daily-report/pdf-fields', { include });
      setMsg({ kind: 'ok', text: 'Saved. Applies to the next Send & Lock.' });
      refresh();
    } catch (e) { setMsg({ kind: 'error', text: e.message || String(e) }); }
    finally { setSaving(false); }
  }
  const toggleAll = (val) => {
    if (!data || !Array.isArray(data.catalog)) return;
    const next = {};
    for (const s of data.catalog) for (const f of s.fields) next[f.id] = val;
    setInclude(next);
  };
  if (loading && !data) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">Error: {error}</div>;
  const catalog = (data && data.catalog) || [];
  // Screen: one checkbox per field, grouped by report section.
  return (
    <div style={{ maxWidth: 640 }}>
      <p className="small" style={{ color: '#64748b' }}>
        Uncheck any field to hide it from the emailed PDF report.
        Sections with no visible rows collapse entirely.
      </p>
      <div style={{ marginBottom: '0.6rem', display: 'flex', gap: '0.4rem' }}>
        <button className="refresh-btn" onClick={() => toggleAll(true)} style={{ background: '#0369a1', fontSize: '0.85em' }}>Check all</button>
        <button className="refresh-btn" onClick={() => toggleAll(false)} style={{ background: '#64748b', fontSize: '0.85em' }}>Uncheck all</button>
      </div>
      {catalog.map(s => (
        <div key={s.section} style={{ marginBottom: '0.9rem' }}>
          <div style={{ fontWeight: 600, marginBottom: '0.25rem', color: '#0f172a',
                        borderBottom: '1px solid #cbd5e1', paddingBottom: '0.15rem' }}>
            {s.section}
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.15rem 1rem' }}>
            {s.fields.map(f => (
              <label key={f.id} className="small" style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
                <input type="checkbox" checked={include[f.id] !== false}
                       onChange={e => setInclude(m => ({ ...m, [f.id]: e.target.checked }))} />
                <span>{f.label}</span>
              </label>
            ))}
          </div>
        </div>
      ))}
      {msg && (
        <div className="small" style={{ padding: '0.35rem 0.5rem', borderRadius: 4, marginBottom: '0.5rem',
                                        background: msg.kind === 'ok' ? '#dcfce7' : '#fee2e2',
                                        color:      msg.kind === 'ok' ? '#166534' : '#991b1b' }}>
          {msg.text}
        </div>
      )}
      <button className="refresh-btn" onClick={save} disabled={saving} style={{ background: '#0369a1' }}>
        {saving ? 'Saving...' : 'Save PDF field settings'}
      </button>
    </div>
  );
}
